/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'app/components/common/Modal.jsx';
import { Breakpoint } from 'react-socks';
import { Link } from 'react-router-dom';

class TrialEndedModal extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.getPlans();
    }

    render() {
        let modalContent = null,
            imageUrl = this.props.app.config.assetsUrl + "/" + this.props.app.config.imageUrl,
            features = [
                {
                    image: `${imageUrl}/pricing-page/rocket.svg`,
                    desc: 'Boost Visibility',
                    subDesc: 'Increase organic reach'
                },
                {
                    image: `${imageUrl}/pricing-page/clock.svg`,
                    desc: 'Save Time',
                    subDesc: 'Simplify content sharing'
                },
                {
                    image: `${imageUrl}/pricing-page/bolt.svg`,
                    desc: 'Brand Consistency',
                    subDesc: 'Reliable social posting'
                },
            ],
            planPrice = 0,
            constants = this.props.app.config.constants;

        if (Object.keys(this.props.plans.details).length === 0) {
            return null;
        }

        planPrice = this.props.plans.details[constants.PUB_LEVEL_15].price[constants.SUBSCRIPTION_TERM_MONTHLY];

        /*
            <div className="trial-ended-compare">
                <Link to="/account/subscription/compare">Compare plans</Link>
            </div>
        */

        modalContent = (
            <div className="trial-ended">
                <div className="trial-ended-header">
                    <h2>Trial Ended - POSTING STOPPED</h2>
                    <div className="trial-end-pitch">Select a premium plan to restart hands-free social sharing</div>
                </div>
                <div className="trial-ended-content">
                    <div className="feature-list">
                        {features.map((feature, i) => {
                            return (
                                <div key={`feature-${i}`} className="feature">
                                    <div className="feature-img">
                                        <Breakpoint desktop only>
                                            <img src={feature.image} height="90" width="auto"/>
                                        </Breakpoint>
                                        <Breakpoint mobile only>
                                            <img src={feature.image} height="75" width="auto"/>
                                        </Breakpoint>
                                    </div>
                                    <div className="feature-desc">
                                        <div className="feature-desc-top">{feature.desc}</div>
                                        <div className="feature-desc-sub">{feature.subDesc}</div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
                <div className="trial-ended-action" onClick={(e) => {
                    this.props.router.navigate("/account/subscription/new?plan=6");
                }} role="button" aria-label="subscribe">
                    Continue
                </div>
            </div>
        )

        return (
            <Modal
                content={modalContent}
                boxClass={"trial-ended-box"}
                mainClass={"trial-ended-content"} />
        );
    }
}

TrialEndedModal.displayName = "TrialEndedModal";

export default TrialEndedModal;
